import type {TypedSchema} from 'schemaDefinition/types';
import type {UpdateLog} from 'services/updateLog';

/**
 * The status enum is pre-localized into `status` in the scene, and `id` is
 * synthesized for the grid (neither is a backend field).
 */
export type UpdateLogRow = Pick<UpdateLog, 'ean' | 'created' | 'updatedBy'> & {
  id: string;
  status?: string;
  title?: string;
};

export const updateLogSchema: TypedSchema<UpdateLogRow> = {
  name: 'updateLog',
  parts: [
    {
      name: 'created',
      type: 'date',
    },
    {
      name: 'ean',
      type: 'text',
    },
    {
      name: 'status',
      type: 'text',
    },
    {
      name: 'title',
      type: 'text',
    },
  ],
};
